<template>
    <cms-modal2 unique="update-pandi-checkup" title="Update P&I Checkup Report">
        <form @submit.prevent="confirmUpdatePandiCheckup">

            <div class="form-group form-row mb-1" :class="{ 'has-error': checkupReportErrors.checkup_date }">
                <label for="checkup-date" class="col-3 col-form-label font-weight-bold">Date :</label>
                <div class="col-9">
                    <input type="date" id="checkup-date" required
                           class="form-control form-control-sm form-control-xs"
                           v-model="checkupReport.checkup_date"
                    >
                    <span class="help-block text-danger" v-if="!!checkupReportErrors.checkup_date">
                        <small><strong>{{ checkupReportErrors.checkup_date }} </strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1"  :class="{ 'has-error': checkupReportErrors.remarks }">
                <label for="checkup-remarks" class="col-3 col-form-label pt-0 font-weight-bold">Remarks :</label>
                <div class="col-9">
                        <textarea class="form-control form-control-sm" id="checkup-remarks" rows="10"
                                  v-model="checkupReport.remarks"
                                  style="resize: none"></textarea>
                </div>
                <span class="help-block text-danger" v-if="!!checkupReportErrors.remarks">
                    <small><strong>{{ checkupReportErrors.remarks }} </strong></small>
                </span>
            </div>

            <div class="form-group form-row mb-2"   :class="{ 'has-error': checkupReportErrors.pandiCheckupAttachment }">
                <label for="checkup-attachment" class="col-3 col-form-label pt-0 font-weight-bold">Attachment :</label>
                <div class="col-9">
                    <div class="custom-file" id="checkup-attachment-container">
                        <input type="file" id="checkup-attachment"
                               class="custom-file-input form-control-sm"
                               accept="application/pdf"
                               @change="updateFileLabel('checkup-attachment')"
                        >
                        <label class="custom-file-label col-form-label-sm text-nowrap" id="checkup-attachment-file-label"
                               for="checkup-attachment"
                        >P & I Report Attachment</label>
                    </div>
                    <span class="help-block text-danger" v-if="!!checkupReportErrors.pandiCheckupAttachment">
                        <small><strong>{{ checkupReportErrors.pandiCheckupAttachment }} </strong></small>
                    </span>
                </div>
            </div>

            <button type="submit" class="btn btn-warning btn-sm btn-xs font-weight-bold float-right">
                <i class="fas fa-save"></i>
                Save Checkup Report
            </button>
        </form>

    </cms-modal2>
</template>

<script>
import { mapActions } from "vuex";
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { formMixin } from "@/mixins/formMixin";
import { dataMixin } from "@/mixins/dataMixin";
import { gateMixin } from "@/mixins/gateMixin";

import CmsModal2 from "@/components/elements/CmsModal2";

export default {
    name: "EditPandiCheckup",

    mixins: [ vueAppMixin, formMixin, dataMixin, gateMixin ],

    components: { CmsModal2 },

    props: {
        viewPandiCheckup: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    data() {
        return {
            checkupReport: {},
            checkupReportErrors: {},
        }
    },

    methods: {
        ...mapActions([
            'updatePandiCheckup'
        ]),

        async confirmUpdatePandiCheckup() {
            if(await this.confirmUpdate()) {
                let formData = new FormData();
                formData.append('pandiCheckupId', this.checkupReport.id);
                formData.append('checkup_date', this.checkupReport.checkup_date);
                formData.append('remarks', this.checkupReport.remarks);
                let fileInput = document.getElementById('checkup-attachment');
                let files = fileInput.files;
                if(files.length && files[0]) {
                    formData.append('pandiCheckupAttachment', files[0]);
                }
                let updatedPandiCheckup = await this.updatePandiCheckup(formData);

                if(updatedPandiCheckup !== false) {
                    if(updatedPandiCheckup.errors) {
                        this.pandiCheckupErrors = updatedPandiCheckup.errors;
                    } else {
                        this.successAlert('P&I Checkup Successfully UPDATED', 'UPDATE');
                        fileInput.value = null;
                        document.getElementById('close-update-pandi-checkup').click();
                        this.checkupReportErrors = {};
                    }
                } else {
                    this.errorAlert('P&I Checkup Failed to UPDATE', 'UPDATE');
                }
            }
        }
    },

    watch: {
        viewPandiCheckup() {
            this.checkupReport = Object.assign({}, this.viewPandiCheckup);
            this.checkupReportErrors = {};
        }
    }

}
</script>

<style scoped>

</style>